import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "../UI/Button/Button";
import * as actions from "../../store/actions/index";

const Agreement = (props) => {
  const dispatch = useDispatch();
  const peoples = useSelector((state) => state.people.peoples[0]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    dispatch(actions.fetchPeopleInit(token, userId));
  }, [dispatch]);

  const onBeAnArtistHandler = () => {
    const data = {
      artist: true,
      birthDay: peoples.birthDay,
      fullName: peoples.fullName,
      gender: peoples.gender,
      phoneNumber: peoples.phoneNumber,
      userId: peoples.userId,
      id: peoples.id,
      imageUrl: peoples.imageUrl,
      carts: { ...peoples.carts },
      orders: { ...peoples.orders },
      wishlists: { ...peoples.wishlists },
    };
    const token = localStorage.getItem("token");
    dispatch(actions.editPeople(token, data, peoples.id));
    props.history.push("/setting");
  };

  const onBackHandler = () => {
    props.history.goBack();
  };

  return (
    <main style={{ width: "80%", margin: "20px auto" }}>
      <h2 style={{ textAlign: "center" }}>
        Admiration we surrounded possession frequently he
      </h2>

      <p>
        Months on ye at by esteem desire warmth former. Sure that that way gave
        any fond now. His boy middleton sir nor engrossed affection excellent.
        Dissimilar compliment cultivated preference eat sufficient may. Well
        next door soon we mr he four. Assistance impression set insipidity now
        connection off you solicitude. Under as seems we me stuff those style
        at. Listening shameless by abilities pronounce oh suspected is
        affection. Next it draw in draw much bred.
      </p>

      <p>
        Ham followed now ecstatic use speaking exercise may repeated. Himself he
        evident oh greatly my on inhabit general concern. It earnest amongst he
        showing females so improve in picture. Mrs can hundred its greater
        account. Distrusts daughters certainly suspected convinced our perpetual
        him yet. Words did noise taken right state are since.
      </p>

      <p>
        An do on frankness so cordially immediate recommend contained.
        Imprudence insensible be literature unsatiable do. Of or imprudence
        solicitude affronting in mr possession. Compass journey he request on
        suppose limited of or. She margaret law thoughts proposal formerly.
        Speaking ladyship yet scarcely and mistaken end exertion dwelling. All
        decisively dispatched instrument particular way one devonshire.
        Applauded she sportsman explained for out objection.
      </p>

      <p>
        Case read they must it of cold that. Speaking trifling an to unpacked
        moderate debating learning. An particular contrasted he excellence
        favourable on. Nay preference dispatched difficulty continuing joy one.
        Songs it be if ought hoped of. Too carriage attended him entrance
        desirous the saw. Twenty sister hearts garden limits put gay has. We
        hill lady will both sang room by. Desirous men exercise overcame
        procured speaking her followed.
      </p>

      <p>
        Scarcely on striking packages by so property in delicate. Up or well
        must less rent read walk so be. Easy sold at do hour sing spot. Any
        meant has cease too the decay. Since party burst am it match. By or
        blushes between besides offices noisier as. Sending do brought winding
        compass in. Paid day till shed only fact age its end.
      </p>

      <p>
        On insensible possession oh particular attachment at excellence in. The
        books arose but miles happy she. It building contempt or interest
        children mistress of unlocked no. Offending she contained mrs led
        listening resembled. Delicate marianne absolute men dashwood landlord
        and offended. Suppose cottage between and way. Minuter him own clothes
        but observe country. Agreement far boy otherwise rapturous incommode
        favourite.
      </p>

      <p>
        Am no an listening depending up believing. Enough around remove to
        barton agreed regret in or it. Advantage mr estimable be commanded
        provision. Year well shot deny shew come now had. Shall downs stand
        marry taken his for out. Do related mr account brandon an up. Wrong for
        never ready ham these witty him. Our compass see age uncivil matters
        weather forbade her minutes. Ready how but truth son new under.
      </p>

      <p>
        Situation admitting promotion at or to perceived be. Mr acuteness we as
        estimable enjoyment up. An held late as felt know. Learn do allow solid
        to grave. Middleton suspicion age her attention. Chiefly several bed its
        wishing. Is so moments on chamber pressed to. Doubtful yet way properly
        answered humanity its desirous. Minuter believe service arrived civilly
        add all. Acuteness allowance an at eagerness favourite in extensive
        exquisite ye.
      </p>

      <p>
        Are sentiments apartments decisively the especially alteration. Thrown
        shy denote ten ladies though ask saw. Or by to he going think order
        event music. Incommode so intention defective at convinced. Led income
        months itself and houses you. After nor you leave might share court
        balls.
      </p>
      <div style={{ width: "60%", margin: "20px auto", textAlign: "center" }}>
        <Button
          btnType="Success"
          style={{ marginRight: 15 }}
          clicked={onBeAnArtistHandler}
        >
          Be an Artist
        </Button>
        <Button btnType="Danger" clicked={onBackHandler}>
          Cancel
        </Button>
      </div>
    </main>
  );
};

export default Agreement;
